import { render, staticRenderFns } from "./queueBox.vue?vue&type=template&id=65944209&scoped=true"
import script from "./queueBox.vue?vue&type=script&lang=js"
export * from "./queueBox.vue?vue&type=script&lang=js"
import style0 from "./queueBox.vue?vue&type=style&index=0&id=65944209&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65944209",
  null
  
)

export default component.exports